export enum VisualMapType {
  CONTINUOUS = 'continuous',
  PIECEWISE = 'piecewise',
}
